$(document).ready(function(){

function myFunction() {
  var btnText = document.getElementById("myBtn");
  var moreText = document.getElementById("more");

// if (moreText.style.display == "none") {
//      btnText.innerHTML = "Read less"; 
//      $("#more").slideDown();
//     // console.log('if')
//   } else {
//     //console.log('else')
//     console.log(moreText.style.display);
//     btnText.innerHTML = "Read more";
//     $("#more").slideUp();
//   }
  
if (moreText.style.display == "block") {
    // console.log('if')
      console.log(moreText.style.display);
    btnText.innerHTML = "Read more";
    $("#more").slideUp();
  } else {
    //console.log('else')
     btnText.innerHTML = "Read less"; 
     $("#more").slideDown();
  }


}


// function myFunction() {
//   var dots = document.getElementById("dots");
//   var moreText = document.getElementById("more");
//   var btnText = document.getElementById("myBtn");

//   if (dots.style.display === "none") {
//     dots.style.display = "inline";
//     btnText.innerHTML = "Read more"; 
//     //moreText.style.display = "none";
//     $("#more").slideUp();
//     console.log(moreText.style.display);
//   } else {
//     dots.style.display = "none";
//     btnText.innerHTML = "Read less"; 
//     //moreText.style.display = "inline";
//      $("#more").slideDown();
//     console.log(moreText.style.display);
//   }
// }

$('body').on('click', '#myBtn',function(){
myFunction();
});





  
$('body').on('click', '.cart__page .cart__item .js-qty__adjust--minus,.cart__page .cart__item .js-qty__adjust--plus',function(){
   var thisevent = $(this);
   var qnty = $(this).parent().find('.js-qty__num').val();
   //console.log(qnty);
   var get_data = $(this).parent().closest('.cart__item').find('.data-mw-relation').attr('data-mw-relation');

if(get_data){
  
$('.cart__item.mw_cart_line').each(function(){
  var item_data = $(this).find('.data-mw-relation').attr('data-mw-relation');
   //console.log(item_data,'item_data');
   //console.log(get_data,'get_data');
  if( item_data == get_data ){
   //console.log('matched');
    $(this).find('.js-qty__num').val(qnty);
  }
  
});
  
}  
   
  
});
  
$('body').on('change', '.cart__page .cart__item .js-qty__num',function(){
   var thisevent = $(this);
    var qnty = $(this).val();
   // console.log(qnty);
    var get_data = $(this).parent().closest('.cart__item').find('.data-mw-relation').attr('data-mw-relation');

    if(get_data){
      $('.cart__item.mw_cart_line').each(function(){
          var item_data = $(this).find('.data-mw-relation').attr('data-mw-relation');
          if( item_data == get_data ){
          //  console.log(get_data);
            $(this).find('.js-qty__num').val(qnty);
          }
  
     });
   }
 
});


$('body').on('click', 'button.cart__update',function(){ 
  //console.log('clickkk');
  $('button.btn.cart__checkout.cart__checkout--page').removeClass("btn--loading");
  $(this).addClass("btn--loading");

});

  
$('body').on('click', 'button.cart__checkout',function(){ 
    if ($('.cart__terms-checkbox').is(':checked')) {
    }else{
      alert('You must agree with the terms and conditions of sales to check out');
      return false;
    }
   
});
  
// $('body').on('click', '.template-collection .boost-sd__toolbar-top-mobile .boost-sd__filter-tree-toggle-button',function(){ 
//   console.log('click')
// $('#boost-sd_filter-tree-mobile').find('.boost-sd__filter-option-label').addClass('boost-sd__filter-option-label--collapsed');
// $('#boost-sd_filter-tree-mobile').find('.boost-sd__filter-option-label button').attr("aria-expanded","false");
// $('#boost-sd_filter-tree-mobile').find('.boost-sd__filter-option-itemwrapper').addClass('boost-sd__filter-option-itemwrapper--collapsed');
   
// });




  });